var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16628_14894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 24.1275C40 24.9474 39.3361 25.6114 38.5161 25.6114H1.48354C0.664158 25.6114 0 24.9474 0 24.1275V1.87245C0 1.05306 0.664158 0.388672 1.48354 0.388672H38.5162C39.3362 0.388672 40.0001 1.05306 40.0001 1.87245L40 24.1275Z",
    fill: "#21246E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2026 7.69212L10.752 18.3123H7.84703L5.65842 9.83771C5.52365 9.31503 5.40848 9.12491 5.00449 8.903C4.34275 8.54515 3.25415 8.20948 2.29297 8.00046L2.3602 7.6922H7.03382C7.62989 7.6922 8.16576 8.08979 8.30053 8.77518L9.45777 14.922L12.3162 7.6922L15.2026 7.69212ZM26.5812 14.8433C26.5941 12.0419 22.7048 11.8894 22.7328 10.6361C22.7404 10.2536 23.103 9.84872 23.8971 9.74651C24.2914 9.69404 25.3765 9.65562 26.6065 10.2202L27.0886 7.96923C26.4268 7.72905 25.5762 7.49902 24.519 7.49902C21.8037 7.49902 19.8921 8.94329 19.876 11.0098C19.8582 12.538 21.2398 13.3907 22.282 13.8996C23.3521 14.4204 23.7098 14.7529 23.7061 15.2199C23.6991 15.9327 22.8523 16.2443 22.0625 16.2582C20.6809 16.2798 19.8796 15.8849 19.2396 15.5868L18.7422 17.9153C19.3832 18.2096 20.57 18.4651 21.7983 18.4802C24.6841 18.4801 26.572 17.0512 26.5812 14.8433ZM33.7517 18.3122H36.2932L34.0756 7.69204H31.7293C31.2021 7.69204 30.7577 7.99952 30.5596 8.47051L26.4396 18.3122H29.3233L29.8957 16.7261H33.4207L33.7517 18.3122ZM30.6861 14.5495L32.1327 10.5618L32.965 14.5495H30.6861ZM19.1287 7.69212L16.8556 18.3122H14.1078L16.3815 7.69204H19.1287V7.69212Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16628_14894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e55f643dc7bd4f1b7f6adbd569e71297.svg";
export { ForwardRef as ReactComponent };